import { setupApi } from '@itz/react-core';
import { getCacheAccessToken, removeCacheToken } from './userService';

export const { axiosInstance, sendRequest, config } = setupApi({
    getAccessToken: () => getCacheAccessToken(),
    onUnauthorized: () => {
        removeCacheToken();
        window.location.href = '/login';
    },
});

// Bản vá CORS/401 (CLAUDE.md): @itz sendRequest luôn tự thêm header `X-Client-Type: WEB`,
// nhưng backend mreport (api-ra.itazteam.com) từ chối header này -> 401. Gỡ header ở mọi request.
axiosInstance.interceptors.request.use((cfg) => {
    if (cfg.headers) {
        if (typeof cfg.headers.delete === 'function') {
            cfg.headers.delete('X-Client-Type');
        } else {
            delete cfg.headers['X-Client-Type'];
        }
    }
    return cfg;
});